import { GridPanelVm } from "../../panels/gridpanel-vm";
import { UrlHelper } from "../html/url-helper";
import { ISqafIcon } from "./debugging";
import { DefaultSettings } from "../../devexpress/settings/defaultsettings";
import { IconSize } from "../../types/shared-enums";
import { StateStoring } from "../settings/statestoring";
import { ControlType } from "../../devexpress/controltype";

export class DebuggingIconsDialogGridVm extends GridPanelVm<ISqafIcon> {
	constructor(dataSource: KnockoutObservableArray<ISqafIcon>) {
		super({ initialHeightPerc: 80 });

		this.applyGridOptions({
			dataSource,
			columns: [
				{
					caption: "Icon Id",
					dataField: "id",
					dataType: "number",
					width: 60
				}, {
					caption: "Icon 16x16",
					dataType: "string",
					cellTemplate: "icon16Template",
					width: DefaultSettings.widthIconsOnly * 1.0,
					alignment: "center",
				}, {
					caption: "Icon 24x24",
					dataType: "string",
					cellTemplate: "icon24Template",
					width: DefaultSettings.widthIconsOnly * 1.5,
					alignment: "center",
				}, {
					caption: "Icon 32x32",
					dataType: "string",
					cellTemplate: "icon32Template",
					width: DefaultSettings.widthIconsOnly * 1.75,
					alignment: "center",
				}, {
					caption: "Icon 48x48",
					dataType: "string",
					cellTemplate: "icon48Template",
					width: DefaultSettings.widthIconsOnly * 2.0,
					alignment: "center",
				}, {
					caption: "Typ",
					dataField: "icotId",
					dataType: "number",
					width: 60
				}, {
					caption: "Filename",
					dataField: "fileName",
					dataType: "string"
				}
			],
			stateStoring: StateStoring.createStateStoring(
				10,
				"DebuggingIcons",
				true,
				ControlType.DataGrid
			)
		});
	}

	public getIconUrl(data: ISqafIcon, iconSize: number) {
		let url = UrlHelper.getIconUrl(data.id, "Exact" + iconSize);
		return url;
	}
}